export default __webpack_public_path__ + "static/054-1d3b01e9bdcd77a2ad3db432d08ac4a2.jpg";